
import ViewBox from 'vux/src/components/view-box/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { getWebSiteName } from '@/api/main'
import store from '@/store'
export default {
name: 'TLayout',
components: {
ViewBox,
Tabbar,
TabbarItem,
Group,
Cell
},
created(){
store.dispatch('GetInfo').then(res => {
document.title = res.data.webSiteName + '-管理员'
}).catch(error=>{
this.$router.replace({ path: '/login' })
})
},
methods: {
handleZhuanYeCount() {
this.$router.push({ path: '/t/zhuanyeCount' })
},
handleBanjiCount() {
this.$router.push({ path: '/t/banjiCount' })
},
handleLists() {
this.$router.push({ path: '/t/studentLists' })
},
handleBanji(){
this.$router.push({ path: '/t/studentBanji' })
}
}
}



// WEBPACK FOOTER //
// ./src/views/layout/TLayout.vue